import React from "react";
import { v4 } from "uuid";
import { getIcon } from "../../Components/Functions";
import { loggedUser } from "../../Constants/menus";
import Api from "../../Server/Api";

const api = new Api();

export const RidersDocument = (props) => {
	const input = React.useRef(null);
	const [name, setName] = React.useState();
	const [documents, setDocuments] = React.useState([]);

	React.useEffect(() => {
		if(props?.documents?.length > 0)setDocuments(props?.documents)
	}, [props?.documents])

	const remove = (id) => {
		const docs = documents.map((e) => {
			if(e.id === id){
				return { ...e, uploading: true }
			}
			return e;
		})
		setDocuments(docs);
		api.del({ endpoint: "file-upload/"+id+"/" }).then((res) => {
			setDocuments(documents.filter(e => e.id !== id))
		})

	}

	const onFileChange = (e) => {
		let files = e.target.files || e.dataTransfer.files;
		if (!files.length) return;
		createImage(files[0]);
	};

	const createImage = (file) => {
		const doc = { id: v4(), name, file, uploading: true };
		const docs = [...documents, doc];
		setDocuments(docs);
		input.current.value = "";
		setName();
		uploadFile(docs, doc);
		props.callback && props.callback([...props.value, doc]);
	};

	const uploadFile = (documents = [], doc) => {
		var formData = new FormData();
		formData.append("name", doc.name);
		formData.append("file", doc.file);
		formData.append("user", props?.userId);
		api.post({
			endpoint: "file-upload/",
			data: formData,
			headers: { "Content-Type": "multipart/form-data" }
		}).then((res) => {
			if(res?.id > 0){
				const docs = documents.map((e) => {
					if(e.id === doc.id){
						return { ...e, id: res.id, uploading: false, url: res.file }
					}
					return e;
				})
				setDocuments(docs)
			}
		})
	}

	return (
		<div className="stepper-form p-0 m-0 w-100">
			<div className="form-sections  px-3 w-100">
				<div id="form-step-1" className="form-section w-100 is-active">
					{/* <h3 className="form-section-title">
						<span>Documents</span>
						<p>
							Upload documents such as license document, certifications,
							verification document etc.
						</p>
					</h3> */}
					<div className="form-section-inner">
                            {!props?.readOnly && (
						<div className="fieldset">
							<div className="field is-grouped">
								<div className="control is-expanded">
									<input	
										ref={input}
										type="text"
										className="input"
										placeholder="Document name"
										onInput={(e) => setName(e.target.value)}
									/>
								</div>
							</div>
							{name && (
								<div className="field">
									<div className="control">
										<input
											id="add-new-file"
											type="file"
											style={{ display: "none" }}
											onChange={(e) => onFileChange(e)}
										/>
										<button
											className={`input-button`}
											onClick={() => {
												document.getElementById("add-new-file").click();
											}}
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width={24}
												height={24}
												viewBox="0 0 24 24"
												fill="none"
												stroke="currentColor"
												strokeWidth={2}
												strokeLinecap="round"
												strokeLinejoin="round"
												className="feather feather-plus"
											>
												<line x1={12} y1={5} x2={12} y2={19} />
												<line x1={5} y1={12} x2={19} y2={12} />
											</svg>
											<span>Add document</span>
										</button>
									</div>
								</div>
							)}
						</div>
                    )}
					</div>

					<div className="form-section-output">
						{documents &&
							documents.map((doc, i) => {
								return (
									<div className={`output `} key={v4()}
										
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width={24}
											height={24}
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											strokeWidth={2}
											strokeLinecap="round"
											strokeLinejoin="round"
											className="feather feather-file-text"
										>
											<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
											<polyline points="14 2 14 8 20 8" />
											<line x1={16} y1={13} x2={8} y2={13} />
											<line x1={16} y1={17} x2={8} y2={17} />
											<polyline points="10 9 9 9 8 9" />
										</svg>

										<span onClick={() => {
											doc.url && window.open(doc.url, "_target");
										}}>{doc?.name || "-No Name-"}</span>

										{!props?.readOnly && (
											<div className="action">
												<button 
													className={`${doc.uploading ? "button is-loading":""} `}
                                                    onClick={() => remove(doc?.id)}
                                                >
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width={24}
														height={24}
														viewBox="0 0 24 24"
														fill="none"
														stroke="currentColor"
														strokeWidth={2}
														strokeLinecap="round"
														strokeLinejoin="round"
														className="feather feather-trash-2"
													>
														<polyline points="3 6 5 6 21 6" />
														<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
														<line x1={10} y1={11} x2={10} y2={17} />
														<line x1={14} y1={11} x2={14} y2={17} />
													</svg>
												</button>
											</div>
										)}
									</div>
								);
							})}
					</div>
				</div>
			</div>
		</div>
	);
};

export const SpecialistServices = (props) => {
	const [name, setName] = React.useState({});

	const [services, setServices] = React.useState(props?.services || []);


	const remove = async (id) => {
		try {
			let d = services;
			const res = await api.del({ endpoint: '/services/'+id+"/", data: {  } })
			const index = d.findIndex(e => e.id === id);
			d.splice(index, 1);
			setServices([...d]);
		} catch (error) {
			console.log(error)
		}
	}

	const saveService = async () => {
		const res = await api.post({ endpoint: '/services/', data: {  ...name, user: loggedUser?.id } })
		if(res?.id) {
			setServices([...services, res])
		}
	}


	return (
		<div className="stepper-form p-0 m-0">
			<div className="form-sections p-0">
				<div id="form-step-1" className="form-section is-active">
					<h3 className="form-section-title">
						<span>Services</span>
						<p>
							Upload documents such as license document, guarantor's form,
							verification document etc.
						</p>
					</h3>
					<div className="form-section-inner">
                            {!props?.readOnly && (
						<div className="fieldset">
							<div className="field is-grouped">
								<div className="control is-expanded">
									<input
										type="text"
										className="input"
										placeholder="Service Title"
										onInput={(e) => setName({ ...name, title: e.target.value})}
									/>
								</div>
							</div>
							
								<div className="field">
									<div className="control">
										<input
											id="add-new-file"
											type="text"
											className="input mb-5"
											// style={{ display: "none" }}
											onInput={(e) => setName({ ...name, description: e.target.value})}
											placeholder={"Service short description"}
										/>

									{/* {name?.title && name?.description && ( */}
										<button
											className="input-button"
											onClick={() => saveService()}
											dangerouslySetInnerHTML={{ __html: getIcon("plus") + '<span>Add Service</span>' }}
										>
										</button>
									{/* )} */}
									</div>
								</div>

						</div>
                    )}
					</div>

					<div className="form-section-output">
						{(services || []).length > 0 && (services || []).map((doc, i) => {
								return (
									<div className="output" key={v4()}>
									

										<div>
										<span style={{ width: "100%", fontWeight: "bold" }}>{doc?.title}</span>
										<p style={{ width: "100%" }}>{doc?.description}</p>
											</div>

										{!props?.readOnly && (
											<div className="action">
												<button 
                                                    onClick={() => remove(doc.id)}
                                                >
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width={24}
														height={24}
														viewBox="0 0 24 24"
														fill="none"
														stroke="currentColor"
														strokeWidth={2}
														strokeLinecap="round"
														strokeLinejoin="round"
														className="feather feather-trash-2"
													>
														<polyline points="3 6 5 6 21 6" />
														<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
														<line x1={10} y1={11} x2={10} y2={17} />
														<line x1={14} y1={11} x2={14} y2={17} />
													</svg>
												</button>
											</div>
										)}
									</div>
								);
							})||(
								<div className="no-messages" style={{ 
									width: "max-content", margin: "auto", textAlign: "center"
								}}>
						<img
							className="light-image mt-5"
							src={require("../../assets/images/undraw_operating_system_re_iqsc.svg").default}
							alt=""
							width="300"
						/>
						<div className="text">
							<h3>No services yet</h3>
							<p>Please add your services here</p>
						</div>
					</div>
							)}
					</div>
				</div>
			</div>
		</div>
	);
};
